
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M10.875 6.125H21M10.875 12.875H21M10.875 19.625H21"></path><path d="M6 4L6 10"></path><path d="M4 14H5.88976C6.73338 14 7.19793 14.9803 6.66371 15.6332L4.83628 17.8668C4.30207 18.5197 4.76662 19.5 5.61024 19.5H8"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiListnumbers",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
